import { useSelector } from 'react-redux'
import { selectLoggedInUser } from '../slices/authSlice'

const useLoggedInUser = () => {
  const loggedInUser = useSelector(selectLoggedInUser)

  return { loggedInUser }
}

export default useLoggedInUser
